import Api from "./Api";

class SoilTypesDataService {
    getAll = () => {
        return Api().get('soil-type')
    }

    get = id => {
        return Api().get(`soil-type/${id}`)
    }

    update = activeSoilType => {
        return Api().put(`soil-type/${activeSoilType.id}`, activeSoilType)
    }

    createSoilType = (data) => {
        return Api().post('soil-type', data)
    }

    getCulture = () => {
        return Api().get('culture')
    }
}

export default new SoilTypesDataService();